var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Cập nhật nhà cung cấp brand",
        visible: _vm.dialogVisible,
        width: "45%",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "editGrade",
          attrs: {
            "label-width": "140px",
            model: _vm.editGrade,
            "label-position": "left",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Brand name", prop: "brandName" } },
            [
              _c("el-input", {
                attrs: {
                  rows: 1,
                  type: "textarea",
                  autosize: "",
                  placeholder: "Nhập brand name",
                },
                model: {
                  value: _vm.editGrade.brandName,
                  callback: function ($$v) {
                    _vm.$set(_vm.editGrade, "brandName", $$v)
                  },
                  expression: "editGrade.brandName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "brandType", label: "Loại brand name" } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { label: true },
                  model: {
                    value: _vm.editGrade.brandTypeCskh,
                    callback: function ($$v) {
                      _vm.$set(_vm.editGrade, "brandTypeCskh", $$v)
                    },
                    expression: "editGrade.brandTypeCskh",
                  },
                },
                [_vm._v("CSKH")]
              ),
              _c(
                "el-checkbox",
                {
                  attrs: { label: true },
                  model: {
                    value: _vm.editGrade.brandTypeAds,
                    callback: function ($$v) {
                      _vm.$set(_vm.editGrade, "brandTypeAds", $$v)
                    },
                    expression: "editGrade.brandTypeAds",
                  },
                },
                [_vm._v("Quảng cáo")]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Ghi chú", prop: "note" } },
            [
              _c("el-input", {
                attrs: {
                  rows: 2,
                  type: "textarea",
                  autosize: "",
                  placeholder: "Nhập ghi chú",
                },
                model: {
                  value: _vm.editGrade.note,
                  callback: function ($$v) {
                    _vm.$set(_vm.editGrade, "note", $$v)
                  },
                  expression: "editGrade.note",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialogByButton("editGrade")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v("Đóng")]),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "success",
                size: "medium",
                loading: _vm.loadingButton,
                mini: "",
              },
              on: {
                click: function ($event) {
                  return _vm.submitForm("editGrade")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v("Lưu")]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }